jQuery(document).ready(function ($) {
    /* ==================== Fonts ==================== */
    const WebFont = require("webfontloader");
    WebFont.load({
        typekit: { id: 'yyz4kra' },
    });
    /* ==================== Menus ==================== */
    const mobileMenuToggle = document.querySelector(".navToggle"), mobileMenu = document.getElementById("mobileNav"), header = document.querySelector("#header"), subMenuItems = document.querySelectorAll(".menu-item-has-children"), mobileSubMenuItems = document.querySelectorAll("#mobileNav .menu-item-has-children"), adminBar = document.getElementById("wpadminbar"), pageContent = document.querySelector(".content-wrap");
    mobileSubMenuItems.forEach((element) => {
        element.addEventListener("click", toggleSubMenu);
    });
    document.querySelectorAll("#mobileNav .sub-menu-wrap .close-submenu").forEach((element) => {
        element.addEventListener("click", (e) => {
            closeSubMenu(e);
        });
    });
    function toggleSubMenu(e) {
        if (e.target === e.currentTarget) {
            this.classList.add("active");
        }
    }
    function closeSubMenu(e) {
        const el = e.currentTarget;
        const parent = el.closest('.menu-item-has-children');
        parent === null || parent === void 0 ? void 0 : parent.classList.remove('active');
        console.log(parent);
    }
    const setHeaderHeight = () => {
        let headerOffset = header.getBoundingClientRect().bottom;
        let adminBarHeight;
        if (adminBar) {
            adminBarHeight = adminBar.offsetHeight;
            header.style.top = `${adminBarHeight}px`;
        }
        else {
            adminBarHeight = 0;
        }
        if (headerOffset && adminBarHeight !== null) {
            //mobileMenu.style.top = `${headerOffset - adminBarHeight}px`;
            mobileMenu.style.minHeight = `calc(100vh - ${headerOffset}px)`;
        }
    };
    // Initialize header and mobile menu height
    setHeaderHeight();
    // Listen for window resizing to update header and mobile menu height as screen size changes
    addEventListener("resize", (event) => {
        setHeaderHeight();
    });
    mobileMenuToggle.addEventListener("click", () => {
        mobileMenuToggle.classList.toggle("is-active");
        mobileMenu.classList.toggle("menu-open");
    });
    // Desktop menu: handle both top-level and one level down
    const allMenuLinks = document.querySelectorAll("#menu-main-menu .menu-item > a");
    allMenuLinks.forEach(link => {
        link.addEventListener("focus", toggleMenu);
        link.parentElement.addEventListener("mouseenter", toggleMenu);
        link.addEventListener("focusout", removeMenu);
    });
    function toggleMenu() {
        const currentItem = this.closest('.menu-item-has-children');
        // Close other open menus except the current branch
        document.querySelectorAll('#menu-main-menu .menu-item-has-children.active').forEach(item => {
            if (!currentItem || (!item.contains(currentItem) && !currentItem.contains(item))) {
                item.classList.remove('active');
            }
        });
        if (currentItem)
            currentItem.classList.add('active');
    }
    function removeMenu(e) {
        const currentItem = this.closest('.menu-item-has-children');
        if (!currentItem.contains(e.relatedTarget)) {
            currentItem.classList.remove('active');
        }
    }
    // Close all when mouse leaves header
    header.addEventListener("mouseleave", () => {
        document.querySelectorAll('#menu-main-menu .menu-item-has-children.active')
            .forEach(item => item.classList.remove('active'));
    });
    /* ==================== Scrolling Classes ==================== */
    let scrollYPos = 0;
    let headerHeight = header.offsetHeight;
    addEventListener("scroll", () => {
        header.classList.toggle("sticky-header", window.scrollY > 0);
        header.classList.toggle("scroll-up", window.scrollY < scrollYPos);
        header.classList.toggle("scroll-down", window.scrollY > scrollYPos);
        scrollYPos = window.scrollY;
    });
});
//Play video from play button
document.querySelectorAll(".play-button").forEach(button => {
    button.addEventListener("click", () => {
        var _a;
        const video = (_a = button.closest(".video-wrapper")) === null || _a === void 0 ? void 0 : _a.querySelector("video");
        if (video) {
            video.play();
            button.style.display = "none";
            video.onended = () => button.style.display = "block";
        }
    });
});
